{
  "general": {
    "article": "Colorway",
    "articles": "Colorways",
    "model": "Style",
    "models": "Styles"
  }
}
